// Brand action types
export const SET_BRAND = "SET_BRAND";
export const DETECT_BRAND = "DETECT_BRAND";

// Action creators
export const setBrand = (brand) => {
  return {
    type: SET_BRAND,
    payload: brand,
  };
};

export const detectBrand = () => {
  const hostname = window.location.hostname.toLowerCase();
  
  let brand = "termovent"; // default brand
  
  // Handle localhost subdomains for development
  if (hostname === "clivet.localhost" || hostname.startsWith("clivet.")) {
    brand = "clivet";
  } else if (hostname === "prolux.localhost" || hostname.startsWith("prolux.")) {
    brand = "prolux";
  } else if (hostname === "termovent.localhost" || hostname.startsWith("termovent.")) {
    brand = "termovent";
  }
  
  return {
    type: DETECT_BRAND,
    payload: brand,
  };
};
